// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-erreurs {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.container-erreurs-header {
  margin: 0 0.5em;
  display: flex;
  justify-content: flex-end;
}

.container-erreurs-body {
  display: block;
  overflow: auto;
  flex: 1 1;
  position: relative;
}

.container-erreurs-body .table {
  width: 100%;
}

.container-erreurs-body table {
  display: grid;
}

.container-erreurs-body table tr {
  display: flex;
  width: 100%;
}

.container-erreurs-body table th div {
  margin: auto;
}

.container-erreurs-body table th .sort {
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}

.container-erreurs-body table th,
.container-erreurs-body table td {
  display: flex;
  width: 25%;
}

.container-erreurs-header input {
  padding: 0.5em;
  margin: 0.5em 0;
}

.container-erreurs-body input {
  height: 100%;
  margin: 0;
}

.footer {
  margin: auto;
  text-align: center;
  border-top: 1px solid lightgray;
  width: 100%;
  text-align: center;
}

.container-erreurs-footer{
  margin: auto;
      border-top: 1px solid;
    width: 100%;
    text-align: center;
}

.container-erreurs-footer p {

  font-size: 90%;
}

.container-erreurs-body table,
.container-erreurs-body th {
  border: 1px solid lightgray;
  border-collapse: collapse;
}

.container-erreurs-body th:has(.checkbox),
.container-erreurs-body td:has(.checkbox) {
  width: 5%;
}

.container-erreurs-body .checkbox {
  margin: auto;
}

.container-erreurs-body td,
.container-erreurs-body th {
  width: 25%;
  box-sizing: border-box;
}

.container-erreurs-body tr:nth-child(even) {
  background-color: hsl(0, 0%, 15%);
}

.container-erreurs-body th {
  text-align: center;
  padding: 2px 10px;
}

.container-erreurs-body .column {
  display: inline-flex;
  margin: 0.5em 0;
  text-align: center;
}

.container-erreurs-body .column p {
  margin: 0 1em;
}

.container-erreurs-body .editable {
  background: initial;
  border: 0;
  color: white;
  font-family: 'Arial';
  font-size: 18px;
  margin: auto;
  width: 100%;
  padding-left: 0.5em;
}

.container-erreurs-body .editable:focus {
  background-color: white;
  color: black;
}
`, "",{"version":3,"sources":["webpack://./src/components/erreurs/erreurs.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;MACR,qBAAqB;IACvB,WAAW;IACX,kBAAkB;AACtB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd","sourcesContent":[".container-erreurs {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.container-erreurs-header {\n  margin: 0 0.5em;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.container-erreurs-body {\n  display: block;\n  overflow: auto;\n  flex: 1;\n  position: relative;\n}\n\n.container-erreurs-body .table {\n  width: 100%;\n}\n\n.container-erreurs-body table {\n  display: grid;\n}\n\n.container-erreurs-body table tr {\n  display: flex;\n  width: 100%;\n}\n\n.container-erreurs-body table th div {\n  margin: auto;\n}\n\n.container-erreurs-body table th .sort {\n  user-select: none;\n  cursor: pointer;\n}\n\n.container-erreurs-body table th,\n.container-erreurs-body table td {\n  display: flex;\n  width: 25%;\n}\n\n.container-erreurs-header input {\n  padding: 0.5em;\n  margin: 0.5em 0;\n}\n\n.container-erreurs-body input {\n  height: 100%;\n  margin: 0;\n}\n\n.footer {\n  margin: auto;\n  text-align: center;\n  border-top: 1px solid lightgray;\n  width: 100%;\n  text-align: center;\n}\n\n.container-erreurs-footer{\n  margin: auto;\n      border-top: 1px solid;\n    width: 100%;\n    text-align: center;\n}\n\n.container-erreurs-footer p {\n\n  font-size: 90%;\n}\n\n.container-erreurs-body table,\n.container-erreurs-body th {\n  border: 1px solid lightgray;\n  border-collapse: collapse;\n}\n\n.container-erreurs-body th:has(.checkbox),\n.container-erreurs-body td:has(.checkbox) {\n  width: 5%;\n}\n\n.container-erreurs-body .checkbox {\n  margin: auto;\n}\n\n.container-erreurs-body td,\n.container-erreurs-body th {\n  width: 25%;\n  box-sizing: border-box;\n}\n\n.container-erreurs-body tr:nth-child(even) {\n  background-color: hsl(0, 0%, 15%);\n}\n\n.container-erreurs-body th {\n  text-align: center;\n  padding: 2px 10px;\n}\n\n.container-erreurs-body .column {\n  display: inline-flex;\n  margin: 0.5em 0;\n  text-align: center;\n}\n\n.container-erreurs-body .column p {\n  margin: 0 1em;\n}\n\n.container-erreurs-body .editable {\n  background: initial;\n  border: 0;\n  color: white;\n  font-family: 'Arial';\n  font-size: 18px;\n  margin: auto;\n  width: 100%;\n  padding-left: 0.5em;\n}\n\n.container-erreurs-body .editable:focus {\n  background-color: white;\n  color: black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
